import { AppRoute } from 'app/app-layout/constants';
import { NavCategoryId } from 'app/app-layout/models/nav/nav-category-ids.enum';
import { NavItemPrimary } from 'app/app-layout/models/nav/nav-item-primary.model';

export class ResultsNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: 'Results',
      categoryId: NavCategoryId.RESULTS,
      categoryIcon: 'ico-nav-results.svg',
      route: AppRoute.noOp,
      menuItems: [
        // new ResultsPlaceholderNavItem(),
      ],
    });
  }
}

// export class ResultsPlaceholderNavItem extends NavItemSecondary {
//   constructor() {
//     super({
//       labelId: 'Placeholder',
//       scopes: [
//         AppScopes.SURVEY_RESULT,
//       ],
//       route: AppRoute.noOp,
//       categoryId: NavCategoryId.RESULTS,
//     });
//   }
// }

